import getISODateToFormatted from './getISODateToFormatted';

export default function getISOEightySixOOneToDateFormatted(dateString) {
  if (!dateString) {
    return '';
  }
  const date = new Date(dateString);
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();

  if (dt < 10) {
    dt = `0${dt}`;
  }
  if (month < 10) {
    month = `0${month}`;
  }

  return getISODateToFormatted(`${year}-${month}-${dt}`);
}
